import React from 'react';
import styled from 'astroturf/react';

import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import routes from 'js/core_pre_webpack/routes';
import _Container from "AnswersMarketingButton-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/AnswersNav/AnswersMarketingButton.tsx?styleId=Container";
import _TextAnchor from "AnswersMarketingButton-TextAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/AnswersNav/AnswersMarketingButton.tsx?styleId=TextAnchor";
import _ButtonAnchor from "AnswersMarketingButton-ButtonAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/AnswersNav/AnswersMarketingButton.tsx?styleId=ButtonAnchor";


interface Props {
  isMobileNav?: boolean;
}

export default function AnswersMarketingButton({ isMobileNav }: Props) {
  if (
    window.location.pathname.toLowerCase().startsWith(routes.answers_path())
  ) {
    return null;
  }

  const Anchor = isMobileNav ? TextAnchor : ButtonAnchor;

  const href = routes.answers_url({
    from_navbar: true,
    trigger: `prominent-nav-button${isMobileNav ? '-mobile' : ''}`,
  });

  return (
    <ImpressionWatcher source="refutation_finder.prominent_nav_button">
      <Container>
        <Anchor href={href}>
          <Icon />
          Answers
        </Anchor>
      </Container>
    </ImpressionWatcher>
  );
}

// Hide button on certain screen widths so it doesn't cut off the search bar placeholder text
const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const TextAnchor = /*#__PURE__*/styled("a", null, {
  displayName: "TextAnchor",
  styles: _TextAnchor
});

const ButtonAnchor = /*#__PURE__*/styled("a", null, {
  displayName: "ButtonAnchor",
  styles: _ButtonAnchor
});

/*
  Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License -
  https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.
*/
export const Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="16"
    width="16"
    fill="none"
    viewBox="0 0 512 512"
  >
    <path
      d={
        'M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 ' +
        '7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-' +
        '10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 ' +
        '85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 ' +
        '88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 ' +
        '14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-' +
        '2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 ' +
        '99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9' +
        ' 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-' +
        '23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 ' +
        '23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-' +
        '4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 ' +
        '10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 ' +
        '448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-' +
        '6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z'
      }
      fill="currentColor"
    />
  </svg>
);
